import React, { useState } from 'react'
import { Modal, Upload, Row, Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import PresetList from '../../../../components/PresetList'
import { useDeepEffect } from '../../../../utils/hooks'
import {
  getPreset
} from '../../../../modules/preset'
import axios from 'axios'
import _, { isNull, isEmpty } from 'lodash'
import {
  beforeUpload,
  getBase64,
  compressFile
} from '../../../../utils/services'

const BarcodePresetModal = (props) => {
  const dispatch = useDispatch()
  const { visible, onOk, onCancel, presetForm } = props
  const [presetSelected, setPresetSelected] = useState({})
  const [select, setSelect] = useState(true)
  const [file, setFile] = useState(null)
  const [imageUrl, setImageUrl] = useState('')
  useDeepEffect(() => {
    if (!isEmpty(presetForm)) {
      setPresetSelected(presetForm)
    }
    async function fetch() {
      await dispatch(getPreset())
    }
    const substring = "preset";
    const string = String(presetForm.imageUrl);
    if (!string.includes(substring)) {
      setImageUrl(presetForm.imageUrl)
    }
    fetch()
    return () => {
      setImageUrl('')
      setFile(null)
    }
  }, [presetForm])

  const { preset } = useSelector(
    (state) => ({
      preset: state.preset.preset
    }),
    []
  )
  console.log(select)

  async function handleChange(info) {
    await getBase64(info.file, (imageUrl) => {
      setImageUrl(imageUrl)
      setSelect(false)
    })
  }

  async function uploadBrandImage(file) {
    try {
      const formData = new FormData()
      formData.append('image', await compressFile(file))
      const token = localStorage.getItem('user-token')
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/barcode/admin-recycle-image`,
        formData,
        {
          headers: {
            'content-type': 'multipart/form-data',
            Authorization: !isNull(token) ? token : ''
          }
        }
      )
      return res.data.url
    } catch (err) {
      return console.log(err)
    }
  }

  function onClickItem(preset) {
    setSelect(true)
    setImageUrl('')
    setFile(null)
    if (preset.cover.url === presetSelected.imageUrl) {
      setPresetSelected({})
    } else {
      setPresetSelected((prevState) => {
        prevState.imageUrl = preset.cover.url
        return { ...prevState }
      })
    }
  }

  const renderItemActive = (item) => {
    let active = false
    if (presetSelected.imageUrl === item.cover.url) {
      active = true
    }
    return active
  }

  const onOkConfirm = async (presetSelected) => {
    if (!isNull(file)) {
      const img = await uploadBrandImage(file)
      setPresetSelected((prevState) => {
        prevState.imageUrl = img
        return { ...prevState }
      })
    }
    setFile(null)
    setImageUrl('')
    onOk(presetSelected)
  }

  return (
    <Modal
      title="เลือกรูปร่าง"
      visible={visible}
      destroyOnClose
      width={1000}
      onOk={() => onOkConfirm(presetSelected)}
      onCancel={() => onCancel()}>
      <Row type="flex" justify="end">
        <div>
          <Upload
            name="img"
            listType="picture-card"
            showUploadList={false}
            beforeUpload={(file) => beforeUpload(file, setFile)}
            onChange={handleChange}
          >
            {imageUrl ? (
              <img src={imageUrl} alt="img" width={64} height={64} />
            ) : (
              <Button type="primary" icon="download">
                อัพโหลดรูปภาพ
              </Button>
            )}
          </Upload>
        </div>
      </Row>
      <PresetList
        presets={preset}
        renderItemActive={renderItemActive}
        select={select}
        onClickItem={onClickItem}
      />
    </Modal>
  )
}

export default BarcodePresetModal
